<template>
  <div>
    <modal-template v-if="show"
                   v-bind="props"
                   @close="closeModal()"
    ></modal-template>
  </div>
</template>

<script>
import bus from 'core/services/Bus.js'
import ModalTemplate from './ModalTemplate.vue'

export default {
  name: 'ModalContainer',
  components: {
    ModalTemplate
  },
  data () {
    return {
      show: false,
      props: {}
    }
  },
  mounted () {
    bus.$on('modal.core:close', () => { this.closeModal() })
    bus.$on('modal.core:open', payload => {
      this.show = true
      this.props = payload.props
    })
  },
  methods: {
    closeModal () {
      this.show = false
      bus.$emit('closeGenericModal')
    }
  }
}
</script>

<style scoped>

</style>
